"use client";

import { memo } from "react";
import { useTranslations } from "next-intl";
import type { ReportTypeConfig } from "../../constants/reportTypes";
import { Button } from "@/components/ui/button";
import { ChevronRight, Loader2 } from "lucide-react";

interface ReportListItemProps {
  config: ReportTypeConfig;
  isLoading?: boolean;
  isError?: boolean;
  onClick?: () => void;
}

const ReportListItem = memo(function ReportListItem({
  config,
  isLoading = false,
  isError = false,
  onClick,
}: ReportListItemProps) {
  const t = useTranslations();

  return (
    <Button
      variant="outline"
      className="text-xs px-0.5 py-0 h-9 flex justify-between rounded-sm"
      disabled={isLoading || isError}
      onClick={onClick}
    >
      {t(config.labelKey)}
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <ChevronRight className="h-4 w-4" />
      )}
    </Button >
  );
});

export default ReportListItem;
